import { render, staticRenderFns } from "./CategoryPageHeader.vue?vue&type=template&id=43d00ed2&scoped=true"
import script from "./CategoryPageHeader.vue?vue&type=script&lang=js"
export * from "./CategoryPageHeader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CategoryPageHeader.vue?vue&type=style&index=0&id=43d00ed2&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "43d00ed2",
  "449745ea"
  
)

export default component.exports